<template>
  <div class="">
    <span class="body-2">{{$t('faq-content.description')}}</span>
    <ul style="list">
      <li v-for="(entry, index) in content" :key="index" class="listentry">
          <span class="question">{{entry.question}}</span><br/>
          <span class="answer">{{entry.answer}}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "FAQContent",
  data: function() {
    var content = this.$t('faq-content.list')
    return {
      content: content
    }
  }
};
</script>
<style scoped>
.question {
  color: inherit;
}
.answer {
  color: var(--v-secondary-lighten2);
}
.listentry {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
}
</style>